import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import { mapGetters } from 'vuex';
export default {
  name: 'ProductOpenGraph',
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    image: {
      type: String,
      required: true
    },
    price: {
      type: Number,
      default: 0
    },
    url: {
      type: String,
      required: true
    },
    isMarketplace: {
      type: Boolean,
      default: false
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    seoDescription() {
      if (!this.isMarketplace) {
        return this.description;
      }

      return "".concat(this.title, " en vente chez Maisons du Monde. D\xE9couvrez toutes les informations sur le produit et nos offres associ\xE9es.");
    }

  }),

  head() {
    return {
      meta: [{
        property: 'og:title',
        content: "".concat(this.title, " | Maisons du Monde")
      }, {
        property: 'og:description',
        content: this.seoDescription
      }, {
        property: 'og:url',
        content: this.url
      }, {
        property: 'og:type',
        content: 'product'
      }, {
        property: 'og:image',
        content: this.image
      }, {
        property: 'og:locale',
        content: this.locale.iso
      }, {
        property: 'product:price:currency',
        content: this.locale.currency
      }, this.price && {
        property: 'product:price:amount',
        content: this.price
      }]
    };
  },

  render: h => h(null)
};